// DS: i8.6
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Approve: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M12 22a9.998 9.998 0 0010-10c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10zm-3.084-8.084a1 1 0 011.414-1.414l.61.61 3.343-3.342a1 1 0 011.415 1.414l-4.05 4.05a1 1 0 01-1.295.102l-.095-.078-1.342-1.342z"
      />
    </svg>
  </IconWrap>
);
Approve.displayName = 'Approve';

export default Approve;
